import React from "react";
import "./MasterTeacher.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import headMt from "../../assets/teacher/siwi_damayanti.webp";
import bodyMt from "../../assets/teacher/siwi_damayanti_rounded.webp";

const MasterTeacher = () => {
  return (
    <React.Fragment>
      <div className="container-teacher">
        <h1 className="title-teacher">
          Our Professional <br /> Master Teacher
        </h1>
        <div className="box-teacher">
          <Swiper
            slidesPerView={3} // default: 4 slides per view
            spaceBetween={40} // ruang antar slide
            navigation={false}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              // ketika lebar layar lebih besar dari 1200px
              1200: {
                slidesPerView: 3, // 4 slides pada layar besar
                spaceBetween: 20, // ruang antar slide
              },
              // ketika lebar layar lebih besar dari 768px
              768: {
                slidesPerView: 3, // 3 slides pada layar sedang
                spaceBetween: 15, // ruang antar slide
              },
              // ketika lebar layar lebih besar dari 480px
              480: {
                slidesPerView: 2, // 2 slides pada layar kecil
                spaceBetween: 10, // ruang antar slide
              },
              // untuk layar lebih kecil dari 480px
              0: {
                slidesPerView: 1, // 1 slide pada layar kecil banget
                spaceBetween: 5, // ruang antar slide
              },
            }}
            className="mySwiper"
          >
            <SwiperSlide className="bgcard-teacher">
              <img
                src="https://tarunapersada.com/storage/images/master-teacher/background-bangun-tri-susilo.webp"
                alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                className="img-header-teacher"
              />
              <div className="parent-child-bg-teacher">
                <h3 className="title-card-teacher">Bangun Tri Susilo</h3>
                <div className="child-bg-teacher">
                  <img
                    src="https://tarunapersada.com/storage/images/master-teacher/bangun-tri-susilo.webp"
                    alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                    className="img-teacher"
                  />
                  <p className="desk-mapel-teacher">
                    <strong>Master Teacher</strong> <br /> SKD | TWK
                  </p>
                </div>
                <img
                  src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                  alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                  className="star-five-teacher"
                />
                <button className="btn-univ-teacher">
                  S1 - Universitas Gajah Mada
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide className="bgcard-teacher">
              <img
                src="https://tarunapersada.com/storage/images/master-teacher/background-mella-narolita.webp"
                alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                className="img-header-teacher"
              />
              <div className="parent-child-bg-teacher">
                <h3 className="title-card-teacher">Mella Narolita</h3>
                <div className="child-bg-teacher">
                  <img
                    src="https://tarunapersada.com/storage/images/master-teacher/mella-narolita.webp"
                    alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                    className="img-teacher"
                  />
                  <p className="desk-mapel-teacher">
                    <strong>Master Teacher</strong> <br /> Psikology | Bahasa
                    Inggris
                  </p>
                </div>
                <img
                  src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                  alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                  className="star-five-teacher"
                />
                <button className="btn-univ-teacher">
                  S2 - Universitas Gajah Mada
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide className="bgcard-teacher">
              <img
                src="https://tarunapersada.com/storage/images/master-teacher/background-lukman-sambodo.webp"
                alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                className="img-header-teacher"
              />
              <div className="parent-child-bg-teacher">
                <h3 className="title-card-teacher">Lukman Sambodo</h3>
                <div className="child-bg-teacher">
                  <img
                    src="https://tarunapersada.com/storage/images/master-teacher/lukman-sambodo.webp"
                    alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                    className="img-teacher"
                  />
                  <p className="desk-mapel-teacher">
                    <strong>Coach</strong> <br /> Bimbingan Jasmani
                  </p>
                </div>
                <img
                  src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                  alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                  className="star-five-teacher"
                />
                <button className="btn-univ-teacher">
                  S1 - UNTAG 1945 Semarang
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide className="bgcard-teacher">
              <img
                src={headMt}
                alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                className="img-header-teacher"
              />
              <div className="parent-child-bg-teacher">
                <h3 className="title-card-teacher">Siwi Damayanti</h3>
                <div className="child-bg-teacher">
                  <img
                    src={bodyMt}
                    alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                    className="img-teacher"
                  />
                  <p className="desk-mapel-teacher">
                    <strong>Master Teacher</strong> <br /> Bahasa Indonesia |
                    TKP
                  </p>
                </div>
                <img
                  src="https://static.vecteezy.com/system/resources/previews/003/355/389/original/five-5-star-rank-sign-illustration-free-vector.jpg"
                  alt="Bimbel Jasmani persiapan Masuk TNI POLRI dan Sekolah Kedinasan"
                  className="star-five-teacher"
                />
                <button className="btn-univ-teacher">
                  S2 - Universitas Negeri Yogyakarta
                </button>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MasterTeacher;
